import { path } from 'ramda'
import { createSelector } from 'reselect'

interface IEmbedTheme {
  timezone?: string
}

const rootSelector = (state) => state.embed

export const themeSelector = (state): IEmbedTheme =>
  path(['configuration', 'theme'], rootSelector(state)) || {}

export const timezoneSelector = createSelector(
  themeSelector,
  (theme) => theme.timezone || 'America/New_York'
)

export const configurationSelector = createSelector(
  rootSelector,
  (root) => root.configuration
)

export const inboxIdSelector = createSelector(
  configurationSelector,
  (configuration) => configuration && configuration.inboxId
)
